import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import i18n from '@/i18n';
import { withDefaults } from 'vue';
import { useI18n } from 'vue-i18n';
import { isSmallDevice } from '@/utils/helpers';
import { useUpdateUser } from '@/composables/user';
import { useUserStore } from '@/store/user';
import { getLanguageId } from '@/utils/helpers';

interface LanguageMenuProps {
    showTitle: boolean;
    theme: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageMenu',
  props: {
    showTitle: { type: Boolean, default: true },
    theme: { default: 'white' }
  },
  setup(__props: any) {

const {
    mutate: updateUser,
    loading: loadingUpdate,
    onDone: onDoneUpdate,
} = useUpdateUser();

const { t } = useI18n();
const userStore = useUserStore();

const items = [
    { title: t('italian'), lang: 'it' },
    { title: t('english'), lang: 'en' },
];

const props = __props;

function getTitle() {
    let lang = 'IT';
    if (i18n.global.locale == 'en') {
        lang = 'EN';
    }
    return props.showTitle ? lang : '';
}

function getButtonColor() {
    const color = props.theme === 'white' ? 'lightGray' : 'white';
    return color;
}

function getTextIconColor() {
    const color = props.theme === 'white' ? 'subtitle' : 'white';
    return color;
}

async function changeLang(lang) {
    i18n.global.locale = lang;
    const newLang = getLanguageId(lang);
    await updateUser({
        id: userStore.getUserId,
        languageId: newLang,
    });
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, { class: "menu-custom" }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps(props, {
        color: getButtonColor(),
        variant: "outlined",
        elevation: "0",
        rounded: "pill"
      }), {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            color: getTextIconColor(),
            class: "mr-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-web")
            ]),
            _: 1
          }, 8, ["color"]),
          _createElementVNode("div", {
            class: _normalizeClass(`text-${getTextIconColor()}`)
          }, _toDisplayString(getTitle()), 3),
          (!_unref(isSmallDevice)())
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                color: getTextIconColor(),
                class: "ml-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" mdi-menu-down ")
                ]),
                _: 1
              }, 8, ["color"]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1040, ["color"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list, {
        class: "font",
        style: {"margin-left":"-50px"}
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(items, (item, index) => {
            return _createVNode(_component_v_list_item, {
              key: index,
              value: index,
              onClick: ($event: any) => (changeLang(item.lang))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, { class: "text-secondary text-body-2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["value", "onClick"])
          }), 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})